import React, { useState, useContext } from 'react';
import Context from "../context/context";
import ReactDOM from 'react-dom';
const Search = props => {
  const {data} = props;
  const {activeFilters, setActiveFilters} = useContext(Context);
  // const [value, setValue] = useState(activeFilters.search.value);
  let searchValue = activeFilters.search.value;
  const updateSearch = (val) => {
    searchValue = val;
    const search = {...activeFilters.search};
    search.value = val;
    setActiveFilters({...activeFilters,
      search
    });

  }
  return ReactDOM.createPortal(
    <div className="search">
        <label className="sr-only" htmlFor={data.name}>{data.title}</label>
        <div className="input-wrapper">
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Vector" d="M15.7812 16.9068L15.7813 16.9069L16.7844 16.8076L16.8962 16.928C16.8962 16.9279 16.8962 16.9279 16.8962 16.9279C17.2133 16.6333 17.2238 16.1422 16.9181 15.8353L16.8017 15.9512L16.9181 15.8353L14.1895 13.0954C14.8812 12.2493 15.2593 11.2053 15.2593 10.1197C15.2593 7.46338 13.0228 5.31228 10.2858 5.31228C7.54879 5.31228 5.31228 7.46338 5.31228 10.1197C5.31228 12.776 7.54879 14.9271 10.2858 14.9271C11.2676 14.9271 12.2064 14.6539 13.0194 14.1336L15.7812 16.9068ZM10.2858 6.8521C12.1607 6.8521 13.6762 8.32344 13.6762 10.1197C13.6762 11.9159 12.1607 13.3873 10.2858 13.3873C8.41097 13.3873 6.89543 11.9159 6.89543 10.1197C6.89543 8.32344 8.41097 6.8521 10.2858 6.8521Z" fill="#00273D" stroke="#00273D" stroke-width="0.328571"/>
        <circle id="Ellipse 1" cx="11.5" cy="11.5" r="10.6786" stroke="#00273D" stroke-width="1.64286"/>
        </svg>
        <input
            type="search"
            name={data.name}
            placeholder={data.title}
            value={searchValue}
            onChange={(e) => updateSearch(e.target.value)}
        />
        </div>
        <button className="button button-search"><span>{data.title}</span></button>

    </div>,
    document.getElementById('outside-root') // The target element outside the root
  );

}

export default Search;
